import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2"
/**
 * Estilos
 */
import './App.css';
/**
 * Servicios
 */
//Importar el espacio de almacenamiento de base de datos firestore
import { pacientesStore, uhCollection, usersCollection, ipwhitelist,padronMedico } from './firebase/config';

/**
 * Pages
 */
//Page asignada al login de acceso al sistema
import Login from './UI_Handler/pages/login';
//Page asignada al control de pacientes pendientes de salida de quirófano
import PacientesSalidaQuirofano from './UI_Handler/pages/pacientesSalidaQuirofano';

import Mantenimiento from './UI_Handler/pages/mantenimiento';

/**
 * Utilerías
 */
//Utilería que contiene funciones necesarias en la lógica del funcionamiento del sitio
import { compararInformación } from './utils/functions';

/**
 * Contenedor general del sitio
 * @returns Devuelve el contenido del sitio
 */
const App = () => {

  //Estado que almacena si se puede accesar
  const [access,setAccess] = useState(false)
  //Estado que indica si la sesión del cliente proviene de una dirección ip valida
  const [isIpValida, setIsIpValida] = useState(true)
  //Estado que almacena la lista de ips validas
  const [ipList, setIpList] = useState([])
  //Estado que almacena la lista de padron medico
  const [padronList, setPadronList] = useState([])
  //Estado que almacena el tiempo en el que se realizara peticion de comprobación de internet
  const [timeLeft, setTimeLeft] = useState();
  //Estado que almacena las unidades hospitalarias obtenidos desde la base de datos en una lista
  const [uhList,setuhList] = useState([])
  //Estado que almacena si hay una sesión guardada
  const [userIsLogged,setUserIslogged] = useState(sessionStorage.getItem('logged'))
  //Estado que almacena el nivel de permiso asignado al usuario logeado
  const [userLevel,setUserLevel] = useState(sessionStorage.getItem('level'))
  //Estado que almacena el nombre del usuario logeado
  const [userName,setUserName] = useState(sessionStorage.getItem('name'))
  //Estado que almacena el nombre del hospital asignado al usuario logeado
  const [userNomHospital,setuserNomHospital] = useState(sessionStorage.getItem('nomHospital'))

  process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";
  
  /**
   * Función que calcula el tiempo de faltante para revisar si se cuenta con conectividad
   * @returns Object Devuelve el tiempo faltante
   */
  const calculateTimeLeft = () => {
    let year = new Date().getFullYear();
    let difference = +new Date(`10/01/${year}`) - +new Date();
  
    let timeLeft = {};
  
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }
  
    return timeLeft;
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 5000);

    return () => clearTimeout(timer);
  });

  useEffect(()=>{
    if(timeLeft && userIsLogged){
      if(!navigator.onLine) {
        Swal.fire({
          icon:"warning",
          title:"Error de conexión",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#04afaa",
          text:"Conexión a internet débil o nula, notifique al área de sistemas por favor.",
          allowOutsideClick:false,
        })
        .then((res)=>{
          if(res.isConfirmed){
            sessionStorage.clear()
            setAccess(false)
            setUserIslogged(false)
          }
        })
      }
    }
  },[timeLeft,userIsLogged])

  useEffect(()=>{
    pacientesStore.collection(ipwhitelist)
        .onSnapshot(snap => {
            const ips = []
            snap.forEach(doc => {
              ips.push({ id: doc.id, ...doc.data() })
            })
            setIpList(ips)
        },(error)=>{  
          setuhList([])
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error,
          })
        })

        pacientesStore.collection(padronMedico)
        .onSnapshot(snap => {
            const padron = []
            snap.forEach(doc => {
              padron.push({ id: doc.id, ...doc.data() })
            })
            setPadronList(padron)
        },(error)=>{  
          setPadronList([])
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error,
          })
        })
  },[])

  useEffect(()=>{
    if(userIsLogged){
      setAccess(true)
      pacientesStore.collection(uhCollection)
        .onSnapshot(snap => {
            const unidadesHospitalarias = []
            snap.forEach(doc => {
              unidadesHospitalarias.push({ identificador: doc.id, ...doc.data() })
            })

            unidadesHospitalarias.sort(compararInformación('hospital'))
            console.log(unidadesHospitalarias)
            setuhList(unidadesHospitalarias)
        },(error)=>{  
          setuhList([])
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error,
          })
        })

      pacientesStore.collection(usersCollection)
            .onSnapshot(snap => {
                const users = []
                snap.forEach(doc => {
                  users.push({ id: doc.id, ...doc.data() })
                })
                console.log(users)
                
                for(let i=0;i<users.length;i++){//Se recorren los usuarios disponibles
                  let unidadHospitalaria = users[i].UnidadHospitalaria
                  if(users[i].id === sessionStorage.getItem('id')){//Se verifica que se este obteniendo la información del usuario loegado
                    
                    if(users[i].Activo){//Se verifica que el usuario loegado este activo
                      //Se actualiza la información del usuario logeado (útil por si se le hacen actualziaciones mientras se encuentra logeado)
                        sessionStorage.setItem('id',users[i].id)
                        sessionStorage.setItem('nomHospital',unidadHospitalaria.hospital)
                        setuserNomHospital(unidadHospitalaria.hospital)
                        sessionStorage.setItem('name',users[i].Nombre)
                        setUserName(users[i].Nombre)
                        sessionStorage.setItem('level',users[i].Permiso)
                        setUserLevel(users[i].Permiso)
                        sessionStorage.setItem('logged',true)
                        setUserIslogged(true)
                    }
                    else{//Se borran los datos de la sesión y se recarga el sitio
                        // sessionStorage.setItem('nomHospital','')
                        // setuserNomHospital('')
                        // sessionStorage.setItem('name','')
                        // setUserName('')
                        // sessionStorage.setItem('level','')
                        // setUserLevel('')
                        // sessionStorage.setItem('logged',false)
                        // setUserIslogged(false)
                    }
                  }
                }
            },(error) =>{
              sessionStorage.setItem('nomHospital','')
              setuserNomHospital('')
              sessionStorage.setItem('name','')
              setUserName('')
              sessionStorage.setItem('level','')
              setUserLevel('')
              sessionStorage.setItem('logged',false)
              setUserIslogged(false)
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error,
              })
            })
    }
    else{
      setAccess(false)
    }
  },[userIsLogged])

  useEffect(()=>{
    if(ipList){
      if(ipList.length > 0){
        validateIps()
      }
      else{
        setIsIpValida(true)
      } 
    }
    else{
      setIsIpValida(true)
    }

    async function validateIps(){
      const response = await geIpAddress()
      const resultado = ipList.find( ip => ip.ip === response.ip)
      if(resultado){
        if(resultado.id){
          setIsIpValida(true)
        }
        else{
          setIsIpValida(false)
        }
      }
      else{
        if("38.65.131.26" === response.ip){
          setIsIpValida(true)
        }
        else{
          setIsIpValida(false)
        }
        
      }
    }
  },[ipList])

  const geIpAddress = async () => {
    const response = await fetch('https://ipapi.co/json/')
    const json = await response.json()
    return json
  }

  return (
    <div className="App">
      {
        isIpValida || !isIpValida
        ?
          access && userName
          ?
            <PacientesSalidaQuirofano userName={userName} userNomHospital={userNomHospital} userLevel={userLevel} uhList={uhList} access={access} padronList={padronList}/>
            // <Mantenimiento />
          :
            <Login setuserNomHospital={setuserNomHospital} setUserName={setUserName} setUserIslogged={setUserIslogged} setUserLevel={setUserLevel} access={access}/>
            // <Mantenimiento />
        :
          <div>
            <h1>Forbidden  Access</h1>
          </div>
      }
    </div>
  );
}

export default App;
